import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import Fire from "../../../api/Fire";
import { useTranslation } from "react-i18next";
import Dialog from "../../../components/Dialog";
import { authErrors } from "../../../utils/errors";
import { Link } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "@firebase/auth";

const Index = (props) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [visible, setVisible] = useState(false);
  const [type, setType] = useState(1);

  useEffect(() => {
    window.document.title = t("login");
    const auth = getAuth();
    const subscriber = onAuthStateChanged(auth, async (user) => {
      if (!user) return;
      if (!user.emailVerified) {
        setType(2);
        setMessage(t("mustVerify"));
        setVisible(true);
        await Fire._signOut();
        setTimeout(() => {
          props.history.push({ pathname: "/" });
        }, [2000]);
      } else {
        props.history.push({ pathname: "/" });
      }
    });
    return () => subscriber();
  }, [t]);

  // login user
  const _login = async (e) => {
    e.preventDefault();
    setLoading((prev) => true);

    try {
      await Fire._signInWithEmailAndPassword(e.target.email.value.trim(), e.target.password.value.trim());
    } catch (error) {
      const code = error.code.split("/")[1];
      setType(2);
      setMessage(authErrors[code]);
      setVisible(true);
    } finally {
      setLoading((prev) => false);
    }
  };

  return (
    <main className="text-center">
      <Row>
        <Col lg={12}>
          <form onSubmit={_login} className="p-5 w-100 mt-5">
            <h2 className="mb-5">
              <strong>{t("login")}</strong>
            </h2>
            <input
              type="email"
              id="email"
              className="form-control border-0 my-3 bg-light p-3 w-100"
              placeholder={t("email-place")}
              required
            />
            <input
              type="password"
              id="password"
              className="form-control border-0 my-3 bg-light p-3 w-100"
              placeholder={t("pass-place")}
              required
            />

            {/* Forgot Password */}
            <div lg="12" className="text-end my-3">
              <Link to="/reset">{t("forgotPassword")}</Link>
            </div>
            {/* Forgot Password */}

            {loading ? (
              <div className="spinner-grow text-success" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            ) : (
              <button id="sign-in-button" className="btn btn-success w-100">
                {t("login")}
              </button>
            )}

            {/* Register */}
            <p className="p mid-text">
              <span>{t("dontHaveAccount")}</span>
            </p>

            <Link to="/register" className="btn btn-outline-success w-100">
              {t("register")}
            </Link>
            {/* Register */}
          </form>
        </Col>
      </Row>

      <Dialog visible={visible} onHide={() => setVisible(false)} message={message} type={type} />
    </main>
  );
};

export default Index;
